import React from 'react';
import '../styles/base/fonts.css'; 

const fontStyles = [
  { label: 'Thin', weight: 100, style: 'normal' },
  { label: 'Thin Italic', weight: 100, style: 'italic' },
  { label: 'ExtraLight', weight: 200, style: 'normal' },
  { label: 'ExtraLight Italic', weight: 200, style: 'italic' },
  { label: 'Light', weight: 300, style: 'normal' },
  { label: 'Light Italic', weight: 300, style: 'italic' },
  { label: 'Regular', weight: 400, style: 'normal' },
  { label: 'Italic', weight: 400, style: 'italic' },
  { label: 'Medium', weight: 500, style: 'normal' },
  { label: 'Medium Italic', weight: 500, style: 'italic' },
  { label: 'SemiBold', weight: 600, style: 'normal' },
  { label: 'SemiBold Italic', weight: 600, style: 'italic' },
  { label: 'Bold', weight: 700, style: 'normal' },
  { label: 'Bold Italic', weight: 700, style: 'italic' },
  { label: 'ExtraBold', weight: 800, style: 'normal' },
  { label: 'ExtraBold Italic', weight: 800, style: 'italic' },
  { label: 'Black', weight: 900, style: 'normal' },
  { label: 'Black Italic', weight: 900, style: 'italic' },
];

const TypographyShowcase = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Urbanist, sans-serif' }}>
      <h1 style={{ marginBottom: '20px' }}>Urbanist Font Showcase</h1>
      {fontStyles.map((font, index) => (
        <div
          key={index}
          style={{
            fontWeight: font.weight,
            fontStyle: font.style,
            fontSize: '20px',
            marginBottom: '10px',
          }}
        >
          {font.label} — The quick brown fox jumps over the lazy dog
        </div>
      ))}
    </div>
  );
};

export default TypographyShowcase;
